import { useLang } from "@/hooks/use-lang";
import { X } from "lucide-react";

interface MapZoomOverlayProps {
  countryName: string;
  onSkip: () => void;
}

const MapZoomOverlay = ({ countryName, onSkip }: MapZoomOverlayProps) => {
  const { lang } = useLang();

  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      {/* Block all interaction during zoom */}
      <div className="absolute inset-0 pointer-events-auto" />

      {/* Country name label */}
      <div className="absolute bottom-20 left-0 right-0 flex justify-center pointer-events-none">
        <div className="px-6 py-3 rounded-2xl bg-background/70 backdrop-blur-xl border border-border/30 shadow-xl animate-fade-in">
          <p className="text-lg font-bold text-foreground tracking-tight">
            {countryName}
          </p>
        </div>
      </div>

      {/* Skip button – top right */}
      <button
        onClick={onSkip}
        className="absolute top-4 right-4 pointer-events-auto inline-flex items-center gap-1.5 px-4 py-2.5 rounded-2xl text-sm font-medium bg-background/60 backdrop-blur-xl border border-border/30 shadow-lg hover:bg-background/80 transition-all text-foreground"
      >
        <X className="w-4 h-4" />
        {lang === "fr" ? "Passer" : "Skip"}
      </button>
    </div>
  );
};

export default MapZoomOverlay;
